
import React from 'react';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import { Navigate } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import TestDashboard from '@/components/testing/TestDashboard';
import { useIsMobile } from '@/hooks/use-mobile';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Settings, User } from 'lucide-react';

const InternalDashboard = () => {
  const { user } = useInternalAuth();
  const isMobile = useIsMobile();

  // Only allow access if user is logged in and is an admin
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-black w-full">
      {!isMobile && <Header />}
      {isMobile && <MobileHeader />}
      
      <main className={`flex-grow w-full px-4 md:px-6 ${
        isMobile 
          ? 'mt-16 mb-16 py-4' 
          : 'mt-24 mb-6 py-6 md:py-12'
      }`}>
        <div className="w-full max-w-7xl mx-auto space-y-6">
          {/* Admin Welcome Section */}
          <Card className="bg-gray-900 border-gray-700">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-white">
                <User className="h-5 w-5 text-sports-green" />
                Admin Internal Dashboard
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-300">
                Welcome, {user.username}! You have administrative access to internal systems.
              </p>
            </CardContent>
          </Card>

          {/* Admin System Testing Suite */}
          <Card className="bg-gray-900 border-gray-700">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-white">
                <Settings className="h-5 w-5 text-sports-green" />
                Admin System Testing Suite
              </CardTitle>
            </CardHeader>
            <CardContent>
              <TestDashboard />
            </CardContent>
          </Card>
        </div>
      </main>
      
      {!isMobile && <Footer />}
      {isMobile && <MobileBottomNav />}
    </div>
  );
};

export default InternalDashboard;
